import { Reveal, SectionTag } from "./Reveal";
import { IMAGES } from "../lib/site";
import { useContent } from "../lib/content";

const PHOTOS = [
    {
        src: IMAGES.lojaNoite,
        alt: "Loja contêiner Conbox com marca iluminada na entrada do condomínio, à noite",
        caption: "Loja contêiner Conbox na entrada do condomínio",
        cls: "sm:col-span-2",
        h: "h-64 sm:h-72",
    },
    {
        src: IMAGES.containerDay,
        alt: "Fachada da loja contêiner Conbox durante o dia",
        caption: "Fachada da loja contêiner",
        cls: "",
        h: "h-64",
    },
    {
        src: IMAGES.phoneQr,
        alt: "Acesso à loja por QR Code no smartphone",
        caption: "Acesso seguro por QR Code",
        cls: "",
        h: "h-64",
    },
    {
        src: IMAGES.interiorGondolas,
        alt: "Gôndonas abastecidas no interior do Conbox",
        caption: "Gôndonas sempre abastecidas",
        cls: "sm:col-span-2",
        h: "h-64",
    },
    {
        src: IMAGES.autoatendimento,
        alt: "Totem de autoatendimento com pagamento por cartão",
        caption: "Autoatendimento: Pix, cartão e aproximação",
        cls: "sm:col-span-2",
        h: "h-64",
    },
];

export default function Galeria() {
    const t = useContent().galeria;
    return (
        <section id="galeria" className="scroll-mt-24 bg-[#F7F4EC] py-20 sm:py-28">
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <Reveal className="max-w-2xl">
                    <SectionTag tone="yellow">Galeria</SectionTag>
                    <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-[#1A231E]">
                        {t.title}
                    </h2>
                    <p className="mt-4 text-base sm:text-lg text-[#1A231E]/70 leading-relaxed">
                        {t.subtitle}
                    </p>
                </Reveal>

                <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:[grid-auto-rows:1fr]" data-testid="gallery-container">
                    {PHOTOS.map((p, i) => (
                        <Reveal key={p.caption} delay={i * 0.07} className={p.cls}>
                            <figure
                                data-testid={`gallery-img-${i + 1}`}
                                className={`group relative w-full ${p.h} rounded-[1.5rem] overflow-hidden border-2 border-[#1A231E]/12 sticker-soft hover:sticker transition-shadow duration-300`}
                            >
                                <img
                                    src={p.src}
                                    alt={p.alt}
                                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#073A22]/75 via-transparent to-transparent opacity-90" />
                                <figcaption className="absolute bottom-4 left-4 right-4 rounded-xl bg-[#F7F4EC]/95 text-[#1A231E] text-sm font-bold px-4 py-2.5 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                                    {p.caption}
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
